import { render, staticRenderFns } from "./ProductCardEditPopup.vue?vue&type=template&id=98d7ec80&"
import script from "./ProductCardEditPopup.vue?vue&type=script&lang=js&"
export * from "./ProductCardEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports